import { MenuState } from '@features/main/interfaces/main.interfaces';
import useAuth from '@hooks/auth.hook';
import { CameraAltOutlined, MoreVertRounded } from '@mui/icons-material';
import { Avatar } from '@features/common';
import clsx from 'clsx';
import useUserInfoStyles from './UserInfo.styles';

interface Props {
	hasToggle?: boolean;
	id: string;
	menuState: MenuState;
	popUpState: boolean;
}

const UserInfo: React.FC<Props> = ({ hasToggle, id, menuState, popUpState }) => {
	const { getEmail, getFullName } = useAuth();
	const classes = useUserInfoStyles();

	return (
		<div
			className={clsx(classes.root, {
				[classes.rootBig]: menuState === 'big',
				[classes.rootPopUp]: popUpState,
				[classes.rootSmall]: hasToggle && menuState === 'small',
				[classes.rootToggle]: !hasToggle,
			})}
			id={id}
		>
			<div className={classes.avatarContainer}>
				<Avatar height={hasToggle ? 44 : 54} width={hasToggle ? 44 : 54} />
				{!hasToggle && (
					<div className={classes.cameraContainer} id="userinfo_camera_button">
						<CameraAltOutlined sx={{ height: 15, width: 15 }} />
					</div>
				)}
			</div>
			{(menuState === 'big' || !hasToggle) && (
				<div className={classes.infoContainer}>
					<div
						className={clsx(classes.infoContainerLeft, {
							[classes.infoContainerLeftBig]: !hasToggle,
						})}
					>
						<p
							className={clsx(classes.fullName, {
								[classes.fullNameBig]: !hasToggle,
							})}
						>
							{getFullName()}
						</p>
						<p className={clsx(classes.email, { [classes.emailBig]: !hasToggle })}>
							{getEmail()}
						</p>
					</div>
					{hasToggle && (
						<div className={classes.infoContainerRight}>
							<MoreVertRounded />
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default UserInfo;
